module.exports = __webpack_public_path__ + "img/1bbeac31c866f6d24b455f23b97c66f0.png";